import { createTheme, ThemeOptions } from '@mui/material/styles';
import { gridClasses } from '@mui/x-data-grid';

// Extend the theme components to include DataGrid
declare module '@mui/material/styles' {
  interface Components {
    MuiDataGrid: {
      styleOverrides?: {
        root?: any;
      };
      defaultProps?: {
        headerAlign?: 'center' | 'left' | 'right';
      };
    };
  }
}

const themeOptions: ThemeOptions = {
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    // Disable automatic font loading
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  palette: {
    primary: {
      main: '#01ABAE',
      light: '#01ABAE',
      dark: '#01ABAE',
      contrastText: '#fff',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
      contrastText: '#fff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '15px',
          fontWeight: 700,
          letterSpacing: '0px',
          lineHeight: '20px',
          textAlign: 'center' as const,
          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
          borderRadius: '4px',
          textTransform: 'none' as const,
          '& .MuiButton-label': {
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
          }
        }
      }
    },
    MuiRadio: {
      defaultProps: {
        color: 'primary',
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small'
      },
      styleOverrides: {
        root: {
          width: '200px',
          '& .MuiInputBase-root': {
            fontSize: '15px',
            fontFamily: '"Roboto"'
          }
        }
      }
    },
    MuiOutlinedInput: {
      defaultProps: {
        size: 'small'
      },
      styleOverrides: {
        root: {
          fontSize: '15px',
          fontFamily: '"Roboto"'
        }
      }
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small'
      },
      styleOverrides: {
        root: {
          fontSize: '15px',
          fontFamily: '"Roboto"'
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme: muiTheme }) => ({
          '&:hover': {
            backgroundColor: muiTheme.palette.action.hover,
          },
          '&.Mui-selected': {
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: muiTheme.palette.action.hover,
            },
          },
        }),
      },
    },
    MuiDataGrid: {
      defaultProps: {
        headerAlign: 'center'
      },
      styleOverrides: {
        root: {
          [`& .${gridClasses.columnHeader}`]: {
            '& .MuiDataGrid-columnHeaderTitleContainer': {
              justifyContent: 'center'
            }
          }
        }
      }
    }
  }
};

export const theme = createTheme(themeOptions);
